import { z } from 'zod';
export const platformMembershipDirectoryEntrySchema = z.strictObject({
    membershipId: z.string().uuid(),
    displayName: z.string().trim().min(1).max(240),
    status: z.literal('active'),
});
export const platformMembershipDirectoryResponseSchema = z.strictObject({
    data: z.array(platformMembershipDirectoryEntrySchema),
});
//# sourceMappingURL=platform-membership-directory.contract.js.map